<template>
<div>
  <div class="wrapper">
    <div class="back" @click="$router.go(-1)"></div>

    <h1 v-if="currentCamera">{{currentCamera.name}}</h1>
        <h1 v-else>...</h1>

    <div class="icon"></div>
      <div class="input">
        <p>Name</p>
        <div class="input-container">
      <input type="email" placeholder="Name" v-model="name" />
      </div>
      </div>
      <div class="input">
        <p>IP</p>
        <div class="input-container">
      <input type="email" placeholder="IP" v-model="ip" />
      </div>
      </div>
      <div class="input">
        <p>URL</p>
        <div class="input-container">
      <input type="email" placeholder="URL" v-model="url" />
      </div>
      </div>
    <button class="button" @click="replaceDetails">
      <p v-if="!loading">Apply changes</p> <loading-wheel v-else /> </button>

    <button class="button delete" @click="open"><p v-if="!loadingDel">Delete Camera</p>
     <loading-wheel v-else /></button>
</div>
  <transition name="fade">
    <dialog-window v-if="modelState"
        title="Are you sure you wish to delete this camera?"
        buttonMsg="Delete"
        @buttonAction="deleteCam"
        @closeModel="modelState = false" />
    </transition>
  </div>
</template>

<script>
import DialogWindow from '../components/DialogWindow.vue';
import awsInfo from '../../public/websocket';
import LoadingWheel from '../components/LoadingWheel.vue';

export default {

  components: { DialogWindow, LoadingWheel },
  data() {
    return {
      name: '',
      ip: '',
      url: '',
      modelState: false,
      onvifCam: false,
      camera: null,
      deleting: false,
      loadingDel: false,
      loading: false,
    };
  },
  computed: {
    cameraDevice() {
      return this.$store.getters.deviceFind(this.currentCamera.id);
    },
    search() {
      let device;

      this.$store.state.devices.deviceList.forEach((element) => {
        element.cameras.forEach((camera) => {
          if (camera.id === this.currentCamera.id) {
            device = element;
          } return 'no';
        });
      });
      return device;
    },
    device() {
      return this.$store.getters.deviceFind(this.currentCamera.id);
    },
    updatedCamera() {
      return this.$store.state.currentUpdatedCamera;
    },
    changeRoute() {
      return this.$store.state.changeRoute;
    },
    fullAddress() {
      const slash = this.url.indexOf('//') + 2;
      const lastSlash = this.url.indexOf('/', slash + 2);
      const ip = this.url.substring(slash, lastSlash);
      return this.url.replace(ip, this.fullUrl);
    },
    fullUrl() {
      const slash = this.url.indexOf('//') + 2;
      const lastSlash = this.url.indexOf('/', slash + 2);
      const portPos = this.url.substring(slash, lastSlash).indexOf(':');
      const fullIp = this.ip
       + this.url.substring(slash, lastSlash).substring(portPos);
      return fullIp;
    },
    currentCamera() {
      return this.$store.getters.camera(this.$route.params.camera);
    },
  },
  methods: {
    replaceDetails() {
      this.loading = true;
      const { camera } = this;
      camera.url = this.fullAddress;
      camera.name = this.name;

      this.$store.dispatch('updateCamera', {
        deviceId: this.cameraDevice.id,
        cameraId:
       this.currentCamera.id,
        camera,
      });
    },

    ipSnip() {
      const slash = this.url.indexOf('//') + 2;
      const firstPort = this.url.indexOf(':');
      const port = this.url.indexOf(':', firstPort + 1);
      this.ip = this.url.substring(slash, port);
    },

    open() {
      this.modelState = true;
    },
    deleteCam() {
      this.loadingDel = true;
      awsInfo.deleteCamera(this.cameraDevice.id, this.currentCamera.id);
      this.modelState = false;
    },
  },
  watch: {
    currentCamera() {
      // for refresh
      awsInfo.getCameraInfo(this.currentCamera.id);
      this.name = this.currentCamera.name;
    },
    updatedCamera(value) {
      this.camera = value;
      this.url = value.url;
      this.ipSnip();
      this.loading = false;
    },
    changeRoute(value) {
      if (value !== false) {
        this.$router.push({ name: 'Cameras' });
      }
    },
  },
  created() {
    // for navigation
    if (this.currentCamera) {
      awsInfo.getCameraInfo(this.currentCamera.id);
      this.name = this.currentCamera.name;
    }
  },

};
</script>

<style scoped>
.button {
  margin-top: 30px;
}
.input:first-of-type {
  margin-top: 82px;
}
.delete {
  background-color: var(--error);
}
button {
  margin-top: 50px;
  width: 210px;
  height: 63px;
  background-color: var(--success);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
}

input::placeholder {
  color: var(--text-faint);
  font-size: 16px;
}

input[type=text],
input[type=password],
input[type=email] {
  height: 50px;
  width: 250px;
  background: transparent;
  border: none;
  box-sizing: border-box;
  padding: 16px 0px 16px 16px;
  font-size: 16px;
}

.input {
  font-weight: bold;
  text-align: left;
  margin-top: 22px;
}
.input p {
  margin-left: 16px;
  margin-bottom: 6px;
}
.input:nth-of-type(2) {
  margin-top: 50px;
}

input:-webkit-autofill{
  transition: background-color 5000000s ease-in-out 0s;
  -webkit-text-fill-color: var(--text) !important;

}
.input-container {
  display: flex;
  border-radius: var(--border-radius);
  background: var(--surface);
}

h1 {
  margin-top: 12px;
font-weight: 500;
font-size: 20px;
}
.wrapper {
  margin-top: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
